import {useFetch} from '@vueuse/core';
import type {I18n} from 'vue-i18n';
import {i18n, i18n_DEFAULT_LOCALE} from '@/locales/i18n';

/**
 * Get the translations for the given locale from the server
 *
 * @param locale
 */
const getTranslationsFromServer = async (locale: string) => {
	const {data} = await useFetch(`${window.websiteBaseUrl}/availability/translations/${locale}`);
	return data.value;
};

/**
 * Get the translations for the given locale from the server and set them to the i18n global instance.
 *
 * @param i18n
 * @param locale
 */
export const setTranslations = async (i18n: I18n, locale: string) => {
	// Get the translations for the given locale
	const translations: string = await getTranslationsFromServer(locale) as string;
	const parsedTranslations = JSON.parse(translations);

	// Set the retrieved translations to the i18n global instance
	i18n.global.setLocaleMessage(locale, parsedTranslations);
};

/**
 * Set the locale for the i18n global instance and load the translations for the given locale if they haven't been
 * loaded yet.
 *
 * @param locale
 */
export const setLocale = async (locale: string) => {
	if (!locale) {
		locale = i18n_DEFAULT_LOCALE;
	}

	(i18n.global.locale as any).value = locale;

	if (JSON.stringify(i18n.global.getLocaleMessage(locale)) === '{}') {
		await setTranslations(i18n, locale);
	}
};
